/**
 * Formas de datos que devuelven los reportes y el motor de surtido.
 *
 * Viven en el paquete compartido para que servidor y PWA hablen exactamente el
 * mismo idioma. Son interfaces puras: los calculos estan en
 * `server/src/intelligence/`.
 */
export const CONFIDENCE_LABELS = {
    high: 'Historial solido',
    medium: 'Historial parcial',
    low: 'Pocos datos',
};
export const URGENCY_LABELS = {
    critical: 'Agotado',
    high: 'Por agotarse',
    normal: 'Conviene surtir',
};
export const PRICE_KIND_LABELS = {
    list: 'Precio de lista',
    wholesale: 'Mayoreo',
    special: 'Precio especial',
};
export const MARGIN_ISSUE_LABELS = {
    negative: 'Se vende por debajo del costo',
    thin: 'Margen muy bajo',
    missing_cost: 'Sin costo registrado',
};
export const PAYMENT_HABIT_LABELS = {
    puntual: 'Paga puntual',
    se_atrasa: 'Se atrasa un poco',
    moroso: 'Paga muy tarde',
    sin_historial: 'Sin historial',
};
export const COLLECTION_URGENCY_LABELS = {
    vencido: 'Vencido',
    vence_hoy: 'Vence hoy',
    proximo: 'Por vencer',
    al_corriente: 'Al corriente',
};
//# sourceMappingURL=analytics.js.map